import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { apiSettings } from '@common/constants'

/** The caller's own access context (from GET /api/v1/me). Drives client-side UI gating only. */
export interface CurrentUser {
  sub: string
  userLevel: string | null
  permissions: string[]
}

interface ApiResult<T> {
  isSuccess: boolean
  data: T | null
  errors: unknown[]
}

@Injectable({ providedIn: 'root' })
export class AccessService {
  constructor(private http: HttpClient) {}

  /** Fetch the current caller's resolved permissions (server-side by `sub`). */
  getCurrentUser(): Observable<ApiResult<CurrentUser>> {
    return this.http.get<ApiResult<CurrentUser>>(
      `${apiSettings.baseApiUrl}/${apiSettings.baseApiVersion}/me`
    )
  }
}
